import { NgModule } from "@angular/core";
import { WhatCanYouDoModalComponent } from "./parental/what-can-you-do-modal/what-can-you-do.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { UiModule } from "../components/ui/ui.module";

import { RouterModule, Route } from "@angular/router";
import { PipesModule } from "../pipes/pipes.module";

export const WhatCanYouDoRoutes: Route[] = [
    { path: '', component: WhatCanYouDoModalComponent },
];

@NgModule({
    declarations: [ WhatCanYouDoModalComponent ],
    imports: [
        TranslateModule,
        CommonModule,
        UiModule,
        RouterModule.forChild(WhatCanYouDoRoutes),
        PipesModule
    ],
    exports: [ WhatCanYouDoModalComponent ]
})

export class WhatCanYouDoModalModule {
    public static components = {
        WhatCanYouDoModalComponent: WhatCanYouDoModalComponent,
    };
}
